import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.PROCUREMENT,
    success: actionTypes.PROCUREMENT_SUCCESS,
    error: actionTypes.PROCUREMENT_ERROR,
  }),
  data: redukers.value({
    set: actionTypes.SET_PROCUREMENT_INFORMATION,
    reset: actionTypes.RESET_PROCUREMENT_INFORMATION,
  }),
})
